import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// The previous cache-first service worker served a stale index.html after
// every deploy (the hashed bundle names rotate), which white-screened
// returning visitors. We no longer register a service worker; unregister()
// tears down any worker a returning visitor still has installed.
serviceWorkerRegistration.unregister();
